(function(){
  'use strict';

  angular.module('eclipseApp.core').directive('contactDetailsSummary', function(){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modules/checkout/views/contact-details-summary-directive.html'
    };
  });
})();
